import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {getScheduleItems, getScheduleItemsTotal} from '../../../selectors/schedule'
import {Schedule as Presentation} from './schedule'
import {ScheduleRuntimeProps, ScheduleOwnProps} from './interfaces'

export const mapRuntime = ({state, actions: {navigateToSchedulePage}}: DetailsPageAppProps): ScheduleRuntimeProps => {
  const componentSettings = state.component.settings

  return {
    items: getScheduleItems(state),
    total: getScheduleItemsTotal(state),
    componentSettings,
    navigateToSchedulePage,
  }
}

export const Schedule = connect<ScheduleOwnProps, ScheduleRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
